export default __webpack_public_path__ + "static/media/pasos-calcular-intereses-prestamo.dda8b76c.jpg";